import { toast } from "sonner";

/**
 * Toasts inside the Infinity Touch customer panel (customer.infinitytouch.app,
 * local dev base path /it-customer) render bottom-center with a light,
 * tone-appropriate color — distinct from the admin/storefront app's default
 * top-center neutral Toaster (App.js). Scoped here via sonner's per-toast
 * options rather than a second <Toaster>, so the rest of the app is
 * unaffected; every customer-infinity page imports `itToast` instead of
 * sonner's `toast` directly.
 */
const base = { position: "bottom-center" };

// Tinted backgrounds with a matching border/text — a step darker than a bare
// tint (was too washed out) but still well short of sonner's built-in
// richColors (solid, more saturated).
const TONE_STYLE = {
  error: { background: "#FECACA", border: "1px solid #EF4444", color: "#7F1D1D" },
  success: { background: "#BBF7D0", border: "1px solid #22C55E", color: "#14532D" },
  info: { background: "#BFDBFE", border: "1px solid #3B82F6", color: "#1E3A8A" },
  warning: { background: "#FDE68A", border: "1px solid #F59E0B", color: "#78350F" },
};

export const itToast = {
  error: (message, opts) => toast.error(message, { ...base, style: TONE_STYLE.error, ...opts }),
  success: (message, opts) => toast.success(message, { ...base, style: TONE_STYLE.success, ...opts }),
  info: (message, opts) => toast.info(message, { ...base, style: TONE_STYLE.info, ...opts }),
  warning: (message, opts) => toast.warning(message, { ...base, style: TONE_STYLE.warning, ...opts }),
};
